import { Component } from "react";
import BCService from "../../../services/BC";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SalesService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
class PayementAvanceBillEspece extends Component {
  state = {
    amount: 0,
    selectedFile: null,
    urlFile: "",
    fileName: "Ticket de caisse",
  };

  constructor(props) {
    super(props);

    this.state = {
      amount: 0,
      fileName: "Ticket de caisse",
      selectedFile: null,
      urlFile: "",
    };

    this.changeAmount = this.changeAmount.bind(this);
    this.onFileChangeHandler = this.onFileChangeHandler.bind(this);
  }

  changeAmount(event) {
    var amount = event.target.value;
    if (amount > this.props.restToPay) {
      this.setState({ alert_message: "error" });
    } else {
      this.setState({ amount: event.target.value });
    }
  }

  refreshPage() {
    window.location.reload(false);
  }

  onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      this.setState({
        fileName: event.target.files[0].name,
      });
      this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      });
    }
  };

  payerBill = (e) => {
    const url = window.location.pathname.split("/")[1];
    if (url === "payerBill") {
      if (this.state.amount === 0) {
        toast.error("Erreur : le champ montant  est vide");
      } else if (this.state.amount > this.props.restToPay) {
        toast.error("Erreur : montant est supérieur au Reste à payer");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),
          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),
          isAvanceOrTotalPayement: 0,
          typePayement: 0,
          ammountPayed: this.state.amount.toString(),
          urlFile: "any",
          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        // if (this.state.selectedFile != null) {
        //   const uploadData = new FormData();
        //   uploadData.append("picture", this.state.selectedFile);

        //   UploadAndDownloadService.uploadFile(
        //     "/retail/uploadFile/uploadFile/Payement",
        //     uploadData
        //   )
        //     .then((response) => {
        //       if (response.data["success"]) {
        //         payFactureOrAvance.urlFile = response.data.success;
        //         BCService.payFactureOrBDC(payFactureOrAvance)
        //           .then((response) => {
        //             console.log(response);
        //             if (response.data["error"]) {
        //               toast.error("Error : il ya un probléme");
        //             } else {
        //               toast.success("ajouté avec succès");

        //               this.refreshPage();
        //             }
        //           })
        //           .catch((error) => {
        //             toast.error("Error : il ya un probléme");

        //             this.refreshPage();
        //           });
        //       } else {
        //         toast.error("Erreur : il ya un probléme au niveau de serveur");
        //       }
        //     })
        //     .catch(() => {
        //       toast.error("Erreur : il ya un probléme de connection");
        //     });

        //   e.preventDefault();
        // } else {

        // }
        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              this.refreshPage();
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            this.refreshPage();
          });
      }
    } else {
      if (this.state.amount === 0) {
        toast.error("Erreur : le champ montant  est vide");
      } else if (this.state.amount > this.props.restToPay) {
        toast.error("Erreur : montant est supérieur au Reste à payer");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),
          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),
          isAvanceOrTotalPayement: 0,
          typePayement: 0,
          ammountPayed: this.state.amount.toString(),
          urlFile: "any",
          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        // if (this.state.selectedFile != null) {
        //   const uploadData = new FormData();
        //   uploadData.append("picture", this.state.selectedFile);

        //   UploadAndDownloadService.uploadFile(
        //     "/retail/uploadFile/uploadFile/Payement",
        //     uploadData
        //   )
        //     .then((response) => {
        //       if (response.data["success"]) {
        //         payFactureOrAvance.urlFile = response.data.success;
        //         BCService.payFactureOrBDC(payFactureOrAvance)
        //           .then((response) => {
        //             console.log(response);
        //             if (response.data["error"]) {
        //               toast.error("Error : il ya un probléme");
        //             } else {
        //               toast.success("ajouté avec succès");

        //               this.refreshPage();
        //             }
        //           })
        //           .catch((error) => {
        //             toast.error("Error : il ya un probléme");

        //             this.refreshPage();
        //           });
        //       } else {
        //         toast.error("Erreur : il ya un probléme au niveau de serveur");
        //       }
        //     })
        //     .catch(() => {
        //       toast.error("Erreur : il ya un probléme de connection");
        //     });

        //   e.preventDefault();
        // } else {

        // }
        SalesService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              this.refreshPage();
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            this.refreshPage();
          });
      }
    }
  };

  render() {
    return (
      <div className="box-body">
        <br />
        <br />
        {/* <label>Charger la ticket de caisse </label> */}
        <br />
        <ToastContainer />

        <div class="row">
          <div class="col-md-4">
            <label>Montant (ne pas dépasser {this.props.restToPay}): </label>
            <input
              type="number"
              min="0"
              step="0.1"
              max={this.props.restToPay.toString()}
              class="form-control"
              placeholder="Montant "
              name="amount"
              value={this.state.amount}
              onChange={this.changeAmount}
            />
          </div>
          <div class="col-md-8">
            <label>Compte bancaire</label>
            <ListBanquesToPayement type={2} />
          </div>
        </div>

        <div class="box-footer">
          <button
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementAvanceBillEspece;
